export default {
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'brandOne10',
  borderColor: false,
  smallText: true,
  padding: ['small', 'small'],
};
